export class ErrorDetail {
  FieldName: string;
  Message: string;
  WarningLevel: WarningLevel;

  constructor(field: string, msg: string, level: WarningLevel) {
    this.FieldName = field;
    this.Message = msg;
    this.WarningLevel = level;
  }
}

export class CTAErrorDetail extends ErrorDetail {
  CallToAction: string;

  constructor(field: string, msg: string, level: WarningLevel, cta: string) {
    super(field, msg, level);
    this.CallToAction = cta;
  }
}

export enum WarningLevel {
  Informational = 0,
  Warning = 1,
  Critical = 2
}
